import { render, staticRenderFns } from "./BeneficiaryDetailModal.vue?vue&type=template&id=6dce9ae0&"
import script from "./BeneficiaryDetailModal.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports